
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-descriptions/[slug]",
      function () {
        return require("private-next-pages/job-descriptions/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-descriptions/[slug]"])
      });
    }
  